module.exports = __webpack_public_path__ + "img/medical.ebe82fba.png";